import React, { useEffect, useState } from 'react';
import { Table } from 'antd';
import { useParams } from 'react-router-dom';
import { paymentLogColumns } from '../../../../../../utils/tableColumns';
import useTranslation from '../../../../../hooks/translation/useTranslation';

function PaymentLogs({
  getService,
}) {
  const { trans } = useTranslation();
  const { id } = useParams();
  const [data, setData] = useState({
    loading: false,
    data: [],
  });

  const fetchData = async () => {
    setData((prevData) => ({
      ...prevData,
      loading: true,
    }));
    try {
      const res = await getService(id);
      setData({
        loading: false,
        data: res,
      });
    } catch (error) {
      setData((prevData) => ({
        ...prevData,
        loading: false,
      }));
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  return (
    <div>
      <div style={{ overflowX: 'auto' }}>
        <Table
          loading={data.loading}
          pagination={false}
          dataSource={data.data}
          columns={paymentLogColumns.map(
            (col) => ({
              ...col,
              title: trans(col.title),
            }),
          )}
        />
      </div>
    </div>
  );
}

export default PaymentLogs;
